'use client';

import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useState } from 'react';

import type { TERM_CATEGORY } from '@/api';
import { UnauthQueryOptions } from '@/api';
import { Selectbox } from '@/components/client';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { useGlobalStore } from '@/stores/GlobalStore';

export const TermsDrawer = () => {
  const [
    termsDrawerType,
    setTermsDrawerType,
    termsDrawerMode,
    setTermsDrawerMode,
  ] = useGlobalStore((state) => [
    state.termsDrawerType,
    state.setTermsDrawerType,
    state.termsDrawerMode,
    state.setTermsDrawerMode,
  ]);

  const { data } = useQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/log-term/{termCategory}']({
      path: {
        termCategory: termsDrawerType as TERM_CATEGORY,
      },
    }),
    enabled: !!termsDrawerType,
  });

  const [order, setOrder] = useState(0);
  const terms = data?.context?.contents;
  const selectedTerms = terms?.[order];
  const newLineFilterContents = selectedTerms?.contents?.replaceAll('\n', '');

  return (
    <ResponsiveDialog
      opened={!!termsDrawerType}
      onClose={() => {
        setTermsDrawerType(null);
        setTermsDrawerMode('default');
        setOrder(0);
      }}
      drawerType={termsDrawerMode === 'bottom' ? 'bottom' : 'full'}
      className={{
        modal: '!min-h-[80vh] max-w-[800px]',
        backdrop:
          termsDrawerMode === 'bottom' ? 'z-[60] bg-Gray-black/50' : undefined,
        drawer: termsDrawerMode === 'bottom' ? 'z-[70]' : undefined,
      }}
    >
      <header className="sticky top-0 bg-Gray-white py-12">
        <h2 className="font-700 typo-body2">{selectedTerms?.title}</h2>
      </header>
      <article
        className="overflow-auto text-[0.875rem] font-400 leading-[150%] text-Gray-900 [&>p]:my-[0.5em] [&_img]:h-auto [&_img]:w-full [&_li]:list-item [&_li]:pl-[0.5em] [&_ol]:list-decimal [&_ol]:pl-[2em] [&_ul]:pl-[2em]"
        dangerouslySetInnerHTML={{
          __html: newLineFilterContents || '',
        }}
      />
      <footer className="sticky bottom-0 w-full bg-Gray-white py-16">
        <Selectbox
          float="top"
          options={terms?.map(({ title, createAt }, index) => ({
            label: `${title} ${dayjs(createAt).format('YYYY.MM.DD')}`,
            value: index,
          }))}
          value={order}
          onChange={(e) => setOrder(e.value)}
        />
      </footer>
    </ResponsiveDialog>
  );
};
